<template>
    <div class="text-justify">
        <div v-html="content" />

        <div class="text-right">
            <button type="button" @click.prevent="nextStep" class="btn btn-primary">
                {{ $root.interactiveInterface.type_name }} indítása!
            </button>
        </div>
    </div>
</template>
<script>
export default {
    props: {
        user: {
            type: Object,
            required: true,
        },
    },
    computed: {
        tasksCount() {
            return window.InteractiveInterfaceTaskCount;
        },
        content() {
            let content = this.$root.interactiveInterface.welcome_message;
            content = content.replaceAll('{user}', this.$root.user.nickname);
            content = content.replaceAll('{email}', this.$root.user.email);
            return content;
        }
    },
    methods: {
        nextStep() {
            this.$emit('next')
        },
    }
}
</script>
